import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';

import {CommonService} from './common.service';

@Injectable({
  providedIn: 'root'
})
export class CeoAuthService {

  constructor(private router: Router,private comserv:CommonService) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const token = localStorage.getItem('userId');
    const userRoletok = localStorage.getItem('userRole');
      
    if(!this.comserv.chkLoginTime()){
      this.router.navigate(['/']);
      return false;
    } else {
      if (token !== null && token !== undefined) {
        if(userRoletok=="ceo"){
          return true;
        } else {
          this.router.navigate(['/']);
          return false;
        }
      } else {
        this.router.navigate(['/']);
        return false;
      }
    }
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // console.log('------Authenticate Child-----------');
    return this.canActivate(route, state);
  }
}
